import type { ReportDayReplayResponse } from "@gettactic/api";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/api";

export const useDayReplayKey = "reportDayReplay";

/**
 * A floor's reservations on one day, for replaying it hour by hour. Nothing
 * is kept from another day: a stale day would colour the new one's map.
 */
export const useDayReplay = (
  floorId: string,
  date: string | undefined,
  isEnabled: boolean
) =>
  useQuery<ReportDayReplayResponse>({
    queryKey: [useDayReplayKey, floorId, date],
    queryFn: async () => {
      if (!date) {
        throw new Error("day replay needs a date");
      }
      const { result } = await api.client.reporting.dayReplay({
        floor_id: floorId,
        date
      });
      if (!result) {
        throw new Error("empty day replay response");
      }
      return result;
    },
    enabled: isEnabled && !!date,
    staleTime: 5 * 60 * 1000
  });
